import React, {Component} from 'react';
import {getAdvertisements, requireSigning, showError} from '../../API/API';
import {Carousel, CarouselControl, CarouselIndicators, CarouselItem, Row} from 'reactstrap';
import Spinner from "react-spinkit";
import {Redirect} from "react-router-dom";
import Axios from 'axios';
import Header from "../Header/Header";
import {logPageView} from "../../AppHelpers/GoogleAnalytics";

class Slider extends Component {

    state = {
        id: null,
        activeIndex: 0,
        items: []
    }

    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.goToIndex = this.goToIndex.bind(this);
        this.onExiting = this.onExiting.bind(this);
        this.onExited = this.onExited.bind(this);
    }

    redirectReceiptHandler = () => {
        this.props.history.push("/receipt", this.state);
    }

    componentWillUnmount() {
        clearInterval(this.token);
    }

    componentDidMount() {
        if (!this.props.location.state || !localStorage.getItem('token')) {
            return;
        }
        const {deviceName} = this.props.location.state;
        this.setState({deviceName, isLoading: true});
        getAdvertisements().then(resp => this.setState({items: resp.data.data, isLoading: false}))
            .catch((e) => {
                showError(e)
                this.setState({isLoading: false})
            });
        this.token = setInterval(() => {
            requireSigning(deviceName)
                .then(res => {
                    if (res.data.data) {
                        this.setState({id: res.data.data.id}, () => this.props.history.push("/receipt", this.state));
                    }
                }).catch(showError);
        }, 30 * 1e3);

        setTimeout(() =>
                requireSigning(deviceName)
                    .then(res => {
                        if (res.data.data) {
                            this.setState({id: res.data.data.id}, () => this.props.history.push("/receipt", this.state));
                        }
                    }).catch(showError)
            , 2e3)
    }

    onExiting() {
        this.animating = true;
    }

    onExited() {
        this.animating = false;
    }

    next() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === this.state.items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({activeIndex: nextIndex});
    }

    previous() {
        if (this.animating) return;
        const nextIndex = this.state.activeIndex === 0 ? this.state.items.length - 1 : this.state.activeIndex - 1;
        this.setState({activeIndex: nextIndex});
    }

    goToIndex(newIndex) {
        if (this.animating) return;
        this.setState({activeIndex: newIndex});
    }


    render() {
        if (!this.props.location.state || !localStorage.getItem('token')) {
            return <Redirect to="/"/>
        }

        logPageView('/slider');
        const {activeIndex} = this.state;
        const slides = this.state.items.map((item) => {
            return (
                <CarouselItem
                    onExiting={this.onExiting}
                    onExited={this.onExited}
                    key={item.url}>
                    <img style={{width: "100%", maxHeight: '80vh'}} src={item.url} alt={item.altText}/>
                    {/*<CarouselCaption captionText={item.title} captionHeader={item.text}/>*/}
                </CarouselItem>
            );
        });

        return (
            <div>
                <Header/>
                <div className="slider-container">
                    {this.state.isLoading &&
                    <div className="d-flex justify-content-center align-items-center mb-5">
                        <Spinner name="circle" fadeIn={0} color="#ccc" className="receipt-loading"/>
                    </div>
                    }
                    <Carousel
                        activeIndex={activeIndex}
                        next={this.next}
                        previous={this.previous}>
                        <CarouselIndicators items={this.state.items} activeIndex={activeIndex}
                                            onClickHandler={this.goToIndex}/>
                        {slides}
                        <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous}/>
                        <CarouselControl direction="next" directionText="Next" onClickHandler={this.next}/>
                    </Carousel>
                    <Row className="justify-content-center p-2 m-2">
                        {/* <Link to="/receipe" className="btn btn-primary" >Next</Link> */}
                        {/* <button className="btn btn-primary" disabled={!this.state.id}
                        onClick={this.redirectReceiptHandler}>Next
                    </button> */}
                    </Row>
                </div>
            </div>
        );
    }
}


export default Slider;
